import { Link } from "react-router-dom";
import { CheckCircle2, RotateCcw } from "lucide-react";
import StepHeader from "@/components/StepHeader";
import { readAdvisorState, resetAdvisorState } from "@/data/polyFitData";
import { trackAdvisorEvent } from "@/utils/analytics";

export default function FitSuccessPage() {
  const advisorState = readAdvisorState();
  const restart = () => {
    const state = resetAdvisorState();
    trackAdvisorEvent("quiz_restarted", { sessionId: state.sessionId, source: "success" });
  };

  return (
    <main className="advisor-page success-page" data-testid="success-page">
      <StepHeader step={4} compact progressLabel="Lead captured" />
      <section className="success-panel reveal-in" data-testid="success-panel">
        <CheckCircle2 size={58} data-testid="success-icon" />
        <p className="step-kicker" data-testid="success-eyebrow">REQUEST RECEIVED</p>
        <h1 data-testid="success-title">Your Poly fit request is in.</h1>
        <p data-testid="success-message">We'll use your recommendation path to help with the right HP Poly headset guidance.</p>
        <p className="route-summary" data-testid="success-routing-summary">Session: {advisorState.sessionId}</p>
        <Link className="primary-cta" to="/" onClick={restart} data-testid="success-start-again-button"><RotateCcw size={16} /> Start Again</Link>
      </section>
    </main>
  );
}